import { render, staticRenderFns } from "./coordinate-picker.vue?vue&type=template&id=6a24f42a&scoped=true"
import script from "./coordinate-picker.vue?vue&type=script&lang=js"
export * from "./coordinate-picker.vue?vue&type=script&lang=js"
import style0 from "./coordinate-picker.vue?vue&type=style&index=0&id=6a24f42a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a24f42a",
  null
  
)

export default component.exports